<div class="w-full h-full bg-[#DCDCDC] text-black flex flex-col items-center p-10 gap-4 overflow-y-auto">
  <div *ngIf="authService.is_admin()" class="flex items-center gap-3">
    <!-- Return to dashboard for admins -->
    <a class="bg-gray-600 text-white rounded-sm py-2 px-5 w-[175px] h-[40px] cursor-pointer transition hover:bg-gray-500" href="/">Back to Dashboard</a>

    <!-- Customer selector for admins -->
    <select class="rounded-sm font-md px-2 py-1 text-black w-[200px] h-full" [(ngModel)]="cid"
      (change)="on_customer_change($event)">
      <option *ngFor="let c of customers" [value]="c">
        {{c}}
      </option>
    </select>
  </div>

  <!-- No valid customer -->
  <div *ngIf="!has_customer" class="flex flex-col items-center bg-white p-8 rounded-xl">
    <h1 class="text-3xl font-bold text-center mb-4">Sorry, you do not have permission to view this page.</h1>
    <p class="text-center text-lg">If this is a mistake, please contact {{ customer_name }} support.</p>
  </div>

  <!-- Live Data Dashboard -->
  <div *ngIf="!show_agreement && show_dashboard" class="flex flex-col items-center bg-white py-14 px-12 w-full max-w-[900px] rounded-xl">
    <h1 class="text-4xl font-bold text-center mb-3">Market Data Dashboard</h1>
    <p class="text-2xl text-gray-500 text-center">{{ customer_name }}</p>

    <div class="mt-[30px] border border-gray-300 flex justify-center items-center gap-2 py-2 px-5 rounded-lg h-[40px]" [ngClass]="{'bg-red-200': !agreement.live_data_access, 'bg-green-200': agreement.live_data_access}">
      <i *ngIf="agreement.live_data_access" class="fa-solid fa-circle-check text-green-800 mt-[1px] text-lg"></i>
      <i *ngIf="!agreement.live_data_access" class="fa-solid fa-circle-xmark text-red-800 mt-[1px] text-lg"></i>

      <p class="font-semibold" *ngIf="agreement.live_data_access">Live Data</p>
      <p class="font-semibold" *ngIf="!agreement.live_data_access">Delayed Data</p>

      <p class="text-xl font-semibold opacity-20">|</p>

      <p class="font-semibold" *ngIf="agreement.pro_access">Professional</p>
      <p class="font-semibold" *ngIf="!agreement.pro_access">Non-Professional</p>
    </div>

    <p *ngIf="authService.get_role() === 'client'" class="text-sm mt-5">As a representative of {{ customer_name }}, you've been assigned Professional user status.</p>

    <div class="w-full pt-[35px] mt-[45px] border-t border-gray-200">
      <h2 class="text-2xl text-center font-bold mb-[25px]">Data Agreements</h2>
      <div class="dashboard-table w-full py-1 px-5 shadow-md">
        <table class="w-full">
          <thead>
            <tr>
              <th></th>
              <th>Status</th>
              <th>Last Updated</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="font-semibold">Exchange Agreements</td>
              <td>
                <div class="flex justify-center">
                  <div *ngIf="agreement?.completed" class="w-auto bg-green-200 flex justify-center items-center gap-2 p-2 rounded-lg">
                    <i class="fa-solid fa-circle-check text-green-800 mt-[1px] text-lg"></i>
                    <p class="leading-none">Complete</p>
                  </div>
                  <div *ngIf="!agreement?.completed" class="bg-yellow-200 flex justify-center items-center gap-2 p-2 rounded-lg">
                    <i class="fa-solid fa-circle-exclamation text-yellow-800 mt-[1px] text-lg"></i>
                    <p class="leading-none">Incomplete</p>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <span *ngIf="agreement?.updated_at">{{ agreement.updated_at | date: 'short'}}</span>
              </td>
              <td class="flex flex-col items-center gap-2">
                <button (click)="toggle_agreement()" class="flex justify-center items-center w-[100px] bg-blue-600 text-white text-sm font-semibold rounded-xl py-2 px-3 cursor-pointer transition hover:bg-blue-500">
                  <span *ngIf="agreement?.completed" class="leading-none">Modify</span>
                  <span *ngIf="!agreement?.completed" class="leading-none">Complete</span>
                </button>
                <button *ngIf="agreement?.completed" (click)="download_agreements()" class="flex justify-center items-center w-[100px] bg-gray-600 text-white text-sm font-semibold rounded-xl py-2 px-3 cursor-pointer transition hover:bg-gray-500">
                  <span class="leading-none">Download</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="subscription_required" class="w-full pt-[50px] mt-[60px] border-t border-gray-200">
      <h2 class="text-2xl text-center font-bold mb-[10px]">Data Subscriptions</h2>
      <p *ngIf="agreement.pro_access" class="text-center text-gray-500 mb-[25px]">As a qualified market Professional, a subscription is required. To receive live data, please sign up below.</p>
      <div class="dashboard-table w-full py-1 px-5 shadow-md">
        <table class="w-full">
          <thead>
            <tr>
              <th class="text-left"></th>
              <th class="text-left">Price</th>
              <th class="text-center">Status</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plan of subscription_plans">
              <td class="text-left">{{ plan.name }}</td>
              <td class="text-left">{{ plan.price }}</td>
              <td class="text-left">
                <div class="flex justify-center">
                  <span *ngIf="plan.active && plan.status === 'active'" class="leading-none bg-green-200 flex justify-center items-center gap-2 p-2 rounded-lg">
                    <i class="fa-solid fa-circle-check text-green-800 text-lg"></i>
                    Active
                  </span>
                  <span *ngIf="plan.active && plan.status === 'pending-cancel'" class="leading-none bg-yellow-200 flex justify-center items-center gap-2 p-2 rounded-lg">
                    <i class="fa-solid fa-circle-exclamation text-yellow-800 text-lg"></i>
                    Pending Cancel
                  </span>
                  <span *ngIf="!plan.active" class="leading-none bg-red-200 flex justify-center items-center gap-2 p-2 rounded-lg">
                    <i class="fa-solid fa-circle-xmark text-red-800 text-lg"></i>
                    Inactive
                  </span>
                </div>
              </td>
              <td class="text-center">
                <div class="flex justify-center items-center">
                  <a *ngIf="plan.active || (!plan.active && !plan.switch)" href="{{ plan.url || '' }}" target="_blank" class="flex justify-center items-center w-[100px] bg-blue-600 text-white text-sm text-center font-semibold rounded-xl py-2 px-3 cursor-pointer transition hover:bg-blue-500">
                    <span *ngIf="plan.active" class="leading-none">Manage</span>
                    <span *ngIf="!plan.active && !plan.switch" class="leading-none">Sign Up</span>
                  </a>
                  <button *ngIf="!plan.active && plan.switch" (click)="confirm_plan_switch(plan)" target="_blank" class="leading-none flex items-center bg-blue-600 text-white text-sm font-semibold rounded-xl py-2 px-3 cursor-pointer transition hover:bg-blue-500">Switch Plans</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Email Verification (gated by !verify_denied) -->
  <div *ngIf="show_agreement && !email_known && !verify_denied" class="flex flex-col items-center bg-white py-14 px-12 w-full max-w-[900px] rounded-xl">
    <h1 class="text-4xl font-bold text-center mb-3">Market Data Exchange Agreement</h1>
    <p *ngIf="customer_name" class="text-2xl text-gray-500 text-center mb-5">{{ customer_name }}</p>

    <!-- Provide Email Address -->
    <div *ngIf="!email_submitted" class="flex flex-col items-center">
      <p class="text-xl text-gray-500 text-center max-w-[640px]">To begin, please enter your email address below and click "Send Code". You will be sent a 6-digit verification code.</p>
      <div class="flex gap-3 mt-5 w-full max-w-[375px] exchange-agreement">
        <input type="email" [(ngModel)]="user_email" class="rounded-lg w-full">
        <button (click)="submit_email_for_verification()" class="bg-blue-600 text-white rounded-lg py-2 px-4 w-[175px] cursor-pointer transition enabled:hover:bg-blue-500 disabled:opacity-30 disabled:cursor-not-allowed">Send Code</button>
      </div>
      <p (click)="toggle_email_submitted()" class="text-center text-sm text-gray-600 mt-5 transition cursor-pointer hover:text-blue-600">If you've already received a code, click here.</p>
    </div>

    <div *ngIf="email_submitted" class="flex flex-col items-center">
      <p class="text-xl text-gray-500 text-center max-w-[600px]">Please enter the 6-digit verification code you received.</p>
      <div class="flex gap-3 mt-5 w-full max-w-[375px] exchange-agreement">
        <input type="text" [(ngModel)]="verification_code" class="rounded-lg w-full">
        <button (click)="validate_verification_code()" class="bg-blue-600 text-white rounded-lg py-2 px-4 w-[175px] cursor-pointer transition enabled:hover:bg-blue-500 disabled:opacity-30 disabled:cursor-not-allowed">Verify Code</button>
      </div>
      <p *ngIf="verify_attempts > 0" class="text-center text-sm text-red-600 mt-3">
        Invalid code. Attempts: {{ verify_attempts }} / {{ MAX_VERIFY_ATTEMPTS }}
      </p>
      <p (click)="toggle_email_submitted()" class="text-center text-sm text-gray-600 mt-5 transition cursor-pointer hover:text-blue-600">If you want to receive another code, click here.</p>
    </div>
  </div>

  <!-- Verification denied — too many failed attempts. Hard-block; reload required. -->
  <div *ngIf="verify_denied" class="flex flex-col items-center bg-white py-14 px-12 w-full max-w-[700px] rounded-xl border-4 border-red-500">
    <i class="fa-solid fa-lock text-red-500 text-6xl mb-4"></i>
    <h1 class="text-3xl font-bold text-center mb-3 text-red-700">Access Denied</h1>
    <p class="text-lg text-gray-600 text-center max-w-[600px] mb-2">
      Email verification failed too many times ({{ MAX_VERIFY_ATTEMPTS }} attempts).
    </p>
    <p class="text-sm text-gray-500 text-center max-w-[600px]">
      For security, this page is blocked for the remainder of your session. Contact your administrator to reset and try again.
    </p>
  </div>

  <!-- Exchange Agreement Form -->
  <div *ngIf="has_customer && cid && show_agreement && email_known" class="flex flex-col items-center bg-white py-14 px-12 w-full max-w-[900px] rounded-xl relative">
    <i *ngIf="agreement.completed" (click)="toggle_agreement()" class="fa-solid fa-xmark absolute top-3 right-3 text-2xl opacity-50 transition cursor-pointer hover:opacity-100"></i>
    <h1 class="text-4xl font-bold text-center mb-2">Market Data Exchange Agreement</h1>
    <p *ngIf="customer_name" class="text-2xl text-gray-500 text-center mb-3">{{ customer_name }}</p>
    <p class="text-xl text-gray-500 text-center">Please complete the form below to receive market data as {{ customer_string }} subscriber.</p>

    <form class="w-full mt-[50px] exchange-agreement" #agreementForm="ngForm">
      <div class="flex gap-5 form-row">
        <div class="grow">
          <p class="label">First Name<span class="text-red-500"> *</span></p>
          <input type="text" name="first_name" [(ngModel)]="agreement.first_name" required>
        </div>
        <div class="grow">
          <p class="label">Last Name<span class="text-red-500"> *</span></p>
          <input type="text" name="last_name" [(ngModel)]="agreement.last_name" required>
        </div>
      </div>

      <div class="flex gap-5 form-row mt-8">
        <div class="grow">
          <p class="label">Email<span class="text-red-500"> *</span></p>
          <input type="email" name="email" [(ngModel)]="agreement.email" [disabled]="email_known" required class="disabled:opacity-50 disabled:cursor-not-allowed">
        </div>
        <div class="grow">
          <p class="label">Phone Number<span class="text-red-500"> *</span></p>
          <input type="tel" name="phone" [(ngModel)]="agreement.phone" required>
        </div>
      </div>

      <div class="grow mt-8">
        <p class="label">Current Street Address<span class="text-red-500"> *</span></p>
        <input type="text" name="address" [(ngModel)]="agreement.address" required>
      </div>

      <div class="grow mt-8">
        <p class="label">Do you live outside of the United States?<span class="text-red-500"> *</span></p>
        <div class="flex gap-5 mt-3">
          <div class="flex items-center gap-2">
            <input type="radio" name="outside_us" id="yes_outside_us" value="yes" [(ngModel)]="agreement.outside_us" required>
            <label for="yes_outside_us">Yes</label>
          </div>
          <div class="flex items-center gap-2">
            <input type="radio" name="outside_us" id="no_outside_us" value="no" [(ngModel)]="agreement.outside_us" required>
            <label for="no_outside_us">No</label>
          </div>
        </div>
      </div>

      <div class="flex gap-5 form-row mt-8">
        <div class="grow">
          <p class="label">City<span class="text-red-500"> *</span></p>
          <input type="text" name="city" [(ngModel)]="agreement.city" required>
        </div>
        <div *ngIf="agreement.outside_us === 'no'" class="grow">
          <p class="label">State<span class="text-red-500"> *</span></p>
          <select name="state" [(ngModel)]="agreement.state">
            <option value="">Select state...</option>
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District Of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </select>
        </div>
        <div *ngIf="agreement.outside_us === 'yes'" class="grow">
          <p class="label">Country<span class="text-red-500"> *</span></p>
          <input type="text" name="country" [(ngModel)]="agreement.country">
        </div>
        <div *ngIf="agreement.outside_us === 'no'" class="grow">
          <p class="label">Zip Code<span class="text-red-500"> *</span></p>
          <input type="text" name="zip_code" [(ngModel)]="agreement.zip_code">
        </div>
      </div>

      <p class="label mt-8">What is your current employment status?<span class="text-red-500"> *</span></p>
      <div class="flex items-center gap-5 mt-4 form-row">
        <div class="flex items-center gap-2">
          <input type="radio" name="employment_status" id="employed" value="employed" [(ngModel)]="agreement.employment_status" required>
          <label for="employed">Employed</label>
        </div>
        <div class="flex items-center gap-2">
          <input type="radio" name="employment_status" id="other" value="other" [(ngModel)]="agreement.employment_status" required>
          <label for="other">Other</label>
        </div>
      </div>

      <!-- Employer Information -->
      <div *ngIf="agreement.employment_status === 'employed'" class="mt-8">
        <div class="flex gap-5 form-row">
          <div class="grow">
            <p class="label">Employer Name<span class="text-red-500"> *</span></p>
            <input type="text" name="employer_name" [(ngModel)]="agreement.employer.name">
          </div>
          <div class="grow">
            <p class="label">Employer Street Address<span class="text-red-500"> *</span></p>
            <input type="text" name="employer_address" [(ngModel)]="agreement.employer.address">
          </div>
        </div>

        <div *ngIf="agreement.employment_status === 'employed'" class="grow mt-8">
          <p class="label">Is your employer located outside of the United States?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="employer_outside_us" id="yes_employer_outside_us" value="yes" [(ngModel)]="agreement.employer_outside_us" required>
              <label for="yes_employee_outside_us">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="employer_outside_us" id="no_employe_outside_us" value="no" [(ngModel)]="agreement.employer_outside_us" required>
              <label for="no_employee_outside_us">No</label>
            </div>
          </div>
        </div>

        <div class="flex gap-5 form-row mt-8">
          <div class="grow">
            <p class="label">Employer City<span class="text-red-500"> *</span></p>
            <input type="text" name="employer_city" [(ngModel)]="agreement.employer.city">
          </div>
          <div *ngIf="agreement.employer_outside_us === 'no'" class="grow">
            <p class="label">Employer State<span class="text-red-500"> *</span></p>
            <select name="employer_state" [(ngModel)]="agreement.employer.state">
              <option value="">Select state...</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
          </div>
          <div *ngIf="agreement.employer_outside_us === 'yes'" class="grow">
            <p class="label">Employer Country<span class="text-red-500"> *</span></p>
            <input type="text" name="employer_country" [(ngModel)]="agreement.employer.country">
          </div>
          <div *ngIf="agreement.employer_outside_us === 'no'" class="grow">
            <p class="label">Employer Zip Code<span class="text-red-500"> *</span></p>
            <input type="text" name="employer_zip_code" [(ngModel)]="agreement.employer.zip_code">
          </div>
        </div>
      </div>

      <!-- Occupation Information -->
      <div *ngIf="agreement.employment_status === 'employed' || agreement.employment_status === 'self-employed'" class="mt-8">
        <div class="flex gap-5 form-row mt-8">
          <div class="grow">
            <p class="label">Occupation<span class="text-red-500"> *</span></p>
            <input type="text" name="occupation" [(ngModel)]="agreement.occupation">
          </div>
          <div class="grow">
            <p class="label">Job Title/Position<span class="text-red-500"> *</span></p>
            <input type="text" name="job_title" [(ngModel)]="agreement.job_title">
          </div>
        </div>

        <div class="grow mt-8">
          <p class="label">Employment Function<span class="text-red-500"> *</span></p>
          <p class="mt-[-2px] mb-[6px] text-sm text-gray-700">Please provide a brief description of the tasks/duties required for your job.</p>
          <input type="text" name="employment_function" [(ngModel)]="agreement.employment_function">
        </div>
      </div>

      <div *ngIf="agreement.employment_status === 'other'" class="mt-8">
        <p class="label">Please explain your current status.<span class="text-red-500"> *</span></p>
        <input type="text" name="other_employment" [(ngModel)]="agreement.other_employment">
      </div>

      <p class="text-gray-600 italic mt-8"><span class="text-red-500"> *</span> We are required by the exchanges to have you fill out this information. Your information is confidential and will not be shared with any third party other than the respective Exchanges who terms you are agreeing to.</p>

      <!-- Non-Professional User Designation -->
      <div class="py-12 my-12 border-y border-gray-300">
        <h2 class="text-3xl text-center font-bold mb-3">Non-Professional User Designation</h2>
        <p class="text-xl text-center text-gray-500">Please answer the questions below to determine whether you currently qualify as a Professional or Nonprofessional subscriber.</p>

        <div class="grow mt-[50px]">
          <p class="label">Do you use Market Data solely for your personal, non-business use?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="personal_use" id="yes_1" value="yes" [(ngModel)]="agreement.questions.personal_use" required>
              <label for="yes_1">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="personal_user" id="no_1" value="no" [(ngModel)]="agreement.questions.personal_use" required>
              <label for="no_1">No</label>
            </div>
          </div>
        </div>

        <div class="grow mt-8">
          <p class="label">Do you receive Market Data for your business or any other entity?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="business_use" id="yes_2" value="yes" [(ngModel)]="agreement.questions.business_use" required>
              <label for="yes_2">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="business_use" id="no_2" value="no" [(ngModel)]="agreement.questions.business_use" required>
              <label for="no_2">No</label>
            </div>
          </div>
        </div>

        <div class="grow mt-8">
          <p class="label">Are you currently registered or qualified with the SEC or the CFTC?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="registered_sec" id="yes_3" value="yes" [(ngModel)]="agreement.questions.registered_sec" required>
              <label for="yes_3">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="registered_sec" id="no_3" value="no" [(ngModel)]="agreement.questions.registered_sec" required>
              <label for="no_3">No</label>
            </div>
          </div>
        </div>

        <div class="grow mt-8">
          <p class="label">Are you currently registered or qualified with any securities agency, any securities exchange, association or regulatory body, or any commodities or futures contract market, association or regulatory body, in the United States or elsewhere?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="registered_agency" id="yes_4" value="yes" [(ngModel)]="agreement.questions.registered_agency" required>
              <label for="yes_4">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="registered_agency" id="no_4" value="no" [(ngModel)]="agreement.questions.registered_agency" required>
              <label for="no_4">No</label>
            </div>
          </div>
        </div>

        <div class="grow mt-8">
          <p class="label">Whether you are located within or outside of the United States, do you perform any functions that are similar to those that require an individual to register or qualify with the SEC, the CFTC, any other securities agency or regulatory body, any securities exchange or association, or any commodities or futures contract market, association or regulatory body?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="perform_functions" id="yes_5" value="yes" [(ngModel)]="agreement.questions.perform_functions" required>
              <label for="yes_5">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="perform_functions" id="no_5" value="no" [(ngModel)]="agreement.questions.perform_functions" required>
              <label for="no_5">No</label>
            </div>
          </div>
        </div>

        <div class="grow mt-8">
          <p class="label">Are you engaged to provide investment advice to any individual or entity?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="investment_advice" id="yes_6" value="yes" [(ngModel)]="agreement.questions.investment_advice" required>
              <label for="yes_6">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="investment_advice" id="no_6" value="no" [(ngModel)]="agreement.questions.investment_advice" required>
              <label for="no_6">No</label>
            </div>
          </div>
        </div>

        <div class="grow mt-8">
          <p class="label">Are you engaged as an asset manager?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="asset_manager" id="yes_7" value="yes" [(ngModel)]="agreement.questions.asset_manager" required>
              <label for="yes_7">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="asset_manager" id="no_7" value="no" [(ngModel)]="agreement.questions.asset_manager" required>
              <label for="no_7">No</label>
            </div>
          </div>
        </div>

        <div class="grow mt-8">
          <p class="label">Do you use the capital of any other individual or entity in the conduct of your trading?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="capital_usage" id="yes_8" value="yes" [(ngModel)]="agreement.questions.capital_usage" required>
              <label for="yes_8">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="capital_usage" id="no_8" value="no" [(ngModel)]="agreement.questions.capital_usage" required>
              <label for="no_8">No</label>
            </div>
          </div>
        </div>

        <div class="grow mt-8">
          <p class="label">Do you conduct trading for the benefit of a corporation, partnership, or other entity?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="entity_trading" id="yes_9" value="yes" [(ngModel)]="agreement.questions.entity_trading" required>
              <label for="yes_9">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="entity_trading" id="no_9" value="no" [(ngModel)]="agreement.questions.entity_trading" required>
              <label for="no_9">No</label>
            </div>
          </div>
        </div>

        <div class="grow mt-8">
          <p class="label">Have you entered into any agreement to share the profit of your trading activities or receive compensation for your trading activities?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="profit_sharing" id="yes_10" value="yes" [(ngModel)]="agreement.questions.profit_sharing" required>
              <label for="yes_10">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="profit_sharing" id="no_10" value="no" [(ngModel)]="agreement.questions.profit_sharing" required>
              <label for="no_10">No</label>
            </div>
          </div>
        </div>

        <div class="grow mt-8">
          <p class="label">Are you receiving office space, and equipment or other benefits in exchange for your trading or work as a financial consultant to any person, firm or business entity?<span class="text-red-500"> *</span></p>
          <div class="flex gap-5 mt-3">
            <div class="flex items-center gap-2">
              <input type="radio" name="benefits_exchange" id="yes_11" value="yes" [(ngModel)]="agreement.questions.benefits_exchange" required>
              <label for="yes_11">Yes</label>
            </div>
            <div class="flex items-center gap-2">
              <input type="radio" name="benefits_exchange" id="no_11" value="no" [(ngModel)]="agreement.questions.benefits_exchange" required>
              <label for="no_11">No</label>
            </div>
          </div>
        </div>
      </div>

      <!-- Exchange Agreement Review -->
      <div class="pb-12 border-b border-gray-300">
        <h2 class="text-3xl text-center font-bold mb-3">Review Exchange Agreements</h2>
        <p class="text-xl text-center text-gray-500">Please click below to view the official agreements provided by NASDAQ, NYSE, and OPRA. After reviewing these terms, you will be asked to acknowledge and agree.</p>
        <div class="flex justify-center items-center gap-4 mt-5">
          <button class="bg-gray-600 text-white rounded-xl py-2 px-5 w-[225px] h-[40px] cursor-pointer transition hover:bg-gray-500" (click)="toggle_forms()">View Agreements</button>
          <div class="flex justify-center items-center gap-2 py-2 px-5 rounded-lg w-[225px] h-[40px]" [ngClass]="{'bg-red-200': !viewed_forms && !agreement.agree_to_forms, 'bg-yellow-200': viewed_forms && !agreement.agree_to_forms, 'bg-green-200': agreement.agree_to_forms}">
            <i *ngIf="!viewed_forms && !agreement.agree_to_forms" class="fa-solid fa-circle-xmark text-red-800 mt-[1px] text-lg"></i>
            <p *ngIf="!viewed_forms && !agreement.agree_to_forms" class="leading-none">Not Started</p>

            <i *ngIf="viewed_forms && !agreement.agree_to_forms" class="fa-solid fa-circle-exclamation text-yellow-800 mt-[1px] text-lg"></i>
            <p *ngIf="viewed_forms && !agreement.agree_to_forms" class="leading-none">Incomplete</p>

            <i *ngIf="agreement.agree_to_forms" class="fa-solid fa-circle-check text-green-800 mt-[1px] text-lg"></i>
            <p *ngIf="agreement.agree_to_forms" class="leading-none">Complete</p>
          </div>
        </div>
        <p class="text-center text-sm mt-5 text-gray-800"><strong>Note:</strong> You must scroll to the bottom of the agreements in order to accept the terms.</p>
      </div>

      <!-- Submit Agreement -->
      <div class="flex flex-col items-center mt-11">
        <div class="flex gap-5 mb-5">
          <input type="checkbox" name="agree_to_terms" [(ngModel)]="agreement.agree_to_terms" (ngModelChange)="eligible_to_submit()" class="w-6 h-6 text-xl mt-1 border-gray-400">
          <p>ACCEPTED AND AGREED: I, the "Subscriber" to which the preceding terms and conditions refer, acknowledge that I have read the preceding terms and conditions, that I understand them, and that I hereby manifest my assent to, and my agreement to comply with, those terms and conditions by entering my full name in the "Signature" field below and clicking on the "Submit Agreements" button below.</p>
        </div>

        <div class="flex gap-5 mb-5">
          <input type="checkbox" name="agree_to_notify" [(ngModel)]="agreement.agree_to_notify" (ngModelChange)="eligible_to_submit()" class="w-6 h-6 text-xl mt-1 border-gray-400">
          <p>I, the "Subscriber", agree that I must notify the Vendor of any change in my circumstances that may cause me to cease to qualify as a Non-professional Subscriber or that may change my response to any of the preceding questions.</p>
        </div>

        <div class="flex gap-5 mb-10">
          <input type="checkbox" name="agree_to_signature" [(ngModel)]="agreement.agree_to_signature" (ngModelChange)="eligible_to_submit()" class="w-6 h-6 text-xl mt-1 border-gray-400">
          <p>I, the "Subscriber", understand that entering my full name in the "Signature" field below represents my electronic signature, which is to be considered under the same conditions as a signature on paper and is legally binding.</p>
        </div>

        <p class="text-sm italic mb-5 text-center">By entering a signature below, I state that I have read and agree to be bound by the information above.</p>
        <div class="flex items-center gap-5 mb-10 w-[500px]">
          <p class="min-w-[150px] leading-none font-semibold">Electronic Signature:</p>
          <input type="text" [(ngModel)]="agreement.electronic_signature" (ngModelChange)="eligible_to_submit()" name="electronic_signature" placeholder="First and Last Name">
        </div>
        
        <button class="bg-blue-600 text-white rounded-xl py-2 px-5 w-[550px] cursor-pointer transition enabled:hover:bg-blue-500 disabled:opacity-30 disabled:cursor-not-allowed" (click)="save_agreement(agreementForm)" [disabled]="!can_save_changes">Submit Agreements</button>
      </div>
    </form>
  </div>
</div>

<!-- Exchange Agreement Viewer -->
<div *ngIf="show_forms == true" class="fixed top-0 left-0 w-screen h-screen text-black py-4 px-6 bg-gray-300 flex flex-col items-center gap-2 z-50">
  <div
    class="flex-1 w-full max-w-[900px] overflow-y-auto bg-white rounded-md shadow-inner p-8 sm:p-10"
    (scroll)="onAgreementsScroll($event)"
  >
    <app-utp-plan-agreement></app-utp-plan-agreement>
    <hr class="my-10 border-t-2 border-gray-300">
    <app-nyse-exhibit-b [vendorName]="env.vendorName"></app-nyse-exhibit-b>
    <hr class="my-10 border-t-2 border-gray-300">
    <app-opra-attachment-b1
      [vendorName]="env.vendorName"
      [contactEmail]="env.contactEmail"
      [selfServiceUrl]="env.selfServiceUrl"
    ></app-opra-attachment-b1>
  </div>

  <div class="flex flex-col items-center py-5" *ngIf="!this.agreement.agree_to_forms">
    <p class="text-center mb-5">Please read through the agreements above. If you acknowledge and agree to the terms listed, click "I Agree" once you've reached the bottom.</p>
    <div class="flex items-center gap-3">
      <button class="bg-blue-600 text-white rounded-xl py-2 px-6 cursor-pointer transition enabled:hover:bg-blue-500 disabled:opacity-30 disabled:cursor-not-allowed" (click)="agree_to_forms()" [disabled]="!scrolled_to_bottom">I Agree</button>
      <button class="bg-gray-700 text-white rounded-xl py-2 px-6 cursor-pointer transition hover:bg-gray-500" (click)="toggle_forms()">Cancel</button>
    </div>
  </div>
  <div class="flex flex-col items-center py-5" *ngIf="this.agreement.agree_to_forms">
    <div class="flex items-center gap-3">
      <button class="bg-gray-700 text-white rounded-xl py-2 px-6 cursor-pointer transition hover:bg-gray-500" (click)="toggle_forms()">Close</button>
    </div>
  </div>
</div>